import { render, staticRenderFns } from "./BinnacleList.vue?vue&type=template&id=3395710e&"
import script from "./BinnacleList.vue?vue&type=script&lang=js&"
export * from "./BinnacleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3395710e')) {
      api.createRecord('3395710e', component.options)
    } else {
      api.reload('3395710e', component.options)
    }
    module.hot.accept("./BinnacleList.vue?vue&type=template&id=3395710e&", function () {
      api.rerender('3395710e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/binnacles/BinnacleList.vue"
export default component.exports